import React, { useContext, useMemo, useEffect, useState } from 'react'
import { navigate } from 'gatsby';

import CollectionProductCard from '@components/productcards/CollectionProductCard'
import QuickBuyModal from '@components/modal/QuickBuyModal'
import FilterList from '@components/ProductListing/FilterList'
import QuickBuyContext from '@context/QuickBuyContext'
import UseWindowSize from '@components/helpers/UseWindowSize'
import { Faders, X } from '@phosphor-icons/react'
import Button1Slot from '@images/icons/btn-1-slot.svg'
import Button2Slot from '@images/icons/btn-2-slot.svg'

import bannerCleaner from '@images/Earth-Day-Collection-Banner-Desktop.webp'
import mobileBannerCleaner from '@images/Earth-Day-Collection-Banner-Mobile.webp'
import LinkButton from '@components/common/LinkButton';

const CollectionsPage = ({products, desktopBannerSrc, mobileBannerSrc, title, collectionCdescription}) => {
    const isCleanerCoasts = typeof window !== 'undefined' && window.location.href.includes('cleaner-coasts-2025-earth-day-fundraiser')

    const [filteredProducts, setFilteredProducts] = useState([]);
    const { width } = UseWindowSize()
    const [banner, setBanner] = useState(desktopBannerSrc)
    const [mobileGridCount, setMobileGridCount] = useState(2)
    
    const [openFilterList, setOpenFilterList] = useState(false)
    const [openQuickBuyModal, setOpenQuickBuyModal] = useState(false)
    const [filterCount, setFilterCount] = useState(0)
    const { quickBuyData, setQuickBuyData, addToBagClicked, setAddToBagClicked, isAddToCart, setIsAddToCart } = useContext(QuickBuyContext)
    const [product, setProduct] =  useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [productsPerPage] = useState(24);
    const [paginatedProducts, setPaginatedProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true)
    const totalPages = Math.ceil(filteredProducts?.length / productsPerPage);
    const [filters, setFilters] = useState([]);

    const productsOriginal = useMemo(() => {
        // Ensure products is an array before spreading it
        return Array.isArray(products) ? [...products] : [];
    }, [products]);
    //const productsOriginal = useMemo(() => [...products], [products]);

    const getPageFromUrl = () => {
        if (typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);
            const page = parseInt(params.get('page'), 10);
            return !isNaN(page) && page > 0 ? page : 1;
        }
    };

    useEffect(() => {
        const page = getPageFromUrl();
        setCurrentPage(page);
        const startIndex = (page - 1) * productsPerPage;
        const endIndex = page * productsPerPage;
        setPaginatedProducts(filteredProducts?.slice(startIndex, endIndex));
        setIsLoading(false)
    }, [typeof window !== 'undefined' && window.location.search, filteredProducts]);

    const handlePageChange = (newPage) => {
        setIsLoading(true)
        if (newPage >= 1 && newPage <= totalPages) {
            navigate(`?page=${newPage}`);
        }
    };

    useEffect(() => {
        if(quickBuyData)
          setOpenQuickBuyModal(true)
          setProduct(quickBuyData)
          setIsAddToCart(false)
    }, [quickBuyData])
    
    useEffect(() => {
        if(addToBagClicked)
            setOpenQuickBuyModal(true)
            setProduct(addToBagClicked)
            setIsAddToCart(true)
    }, [addToBagClicked])


    useEffect(() => {
		setMobileGridCount(2)
        if(width > 1280) {
            setOpenFilterList(true)
            setBanner(desktopBannerSrc)
        } else { 
            setOpenFilterList(false)
            setBanner(mobileBannerSrc)
        }
    }, [width])
    
    useEffect(() => {
        if(width > 1280) return
    
        if(openFilterList) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'auto'
        }
    
    }, [openFilterList])
    
    const handleFilters = (filters) => {
        if(filters) {
            setFilters(filters);
            //console.log("handleFilters:",filters)
            let count = 0

            Object.values(filters).map((opts) => {
                if(!opts.length) count += 1
                else if(opts) {
                    count += opts.length
                } 
            })
            setFilterCount(count)
        }
    }

    useEffect(() => {

        const sortValues = Object.entries(filters)
            .filter(([key]) => key === "sortBy")
            .flatMap(([_, items]) =>
                items && typeof items === "object" && !Array.isArray(items) && items.value
                ? [items.value] // If `items` is a single object with a `value` property
                : Array.isArray(items) 
                    ? items.map((item) => item.value).filter(Boolean) // If `items` is an array of objects with `value`
                    : []
            );
        
        if(sortValues?.length > 0) {
            if(sortValues.includes("featured")) {
                setFilteredProducts(productsOriginal);
            } else {
                const sortedProduct = sortProducts(products, sortValues[0]);
                setFilteredProducts(sortedProduct);

                const page = getPageFromUrl();
                setCurrentPage(page);
                const startIndex = (page - 1) * productsPerPage;
                const endIndex = page * productsPerPage;
                setPaginatedProducts(filteredProducts?.slice(startIndex, endIndex));
            }

        } else {
            setFilteredProducts(productsOriginal);
        }

        const filterValues = Object.entries(filters)
            .filter(([key]) => key !== "sortBy")
            .flatMap(([_, items]) => 
                Array.isArray(items) 
                ? items.filter((item) => item.isChecked).map((item) => item.value) 
                : []
            );

        //console.log("filterValues", filterValues)
        
        if(filterValues.length > 0) {
            const filteredProductsLocal = products?.filter((product) =>
                product.tags.some((tag) =>
                    filterValues?.some((size) => tag.toLowerCase().includes(size.toLowerCase()))
                )
            );
    
            if(filteredProductsLocal?.length > 0) {
                setFilteredProducts(filteredProductsLocal)
            } else {
                if(filterValues?.length > 0) {
                    setFilteredProducts(filteredProductsLocal)
                } else {
                    if(sortValues?.length > 0) {
                        const sortedProduct = sortProducts(products, sortValues[0]);
                        setFilteredProducts(sortedProduct);
                    } else {
                        const sortedProduct = sortProducts(products, "filter_bestseller");
                        setFilteredProducts(sortedProduct);
                    }
                }
            }
        }
        
    }, [filters]);

    

    const sortProducts = (products, sortBy) => {
        switch (sortBy) {
          case "filter_a_z":
            return products.sort((a, b) => a.title.localeCompare(b.title));
      
          case "filter_z_a":
            return products.sort((a, b) => b.title.localeCompare(a.title));
      
          case "filter_high":
            return products.sort((a, b) => 
              a?.priceRangeV2?.minVariantPrice?.amount - b?.priceRangeV2?.minVariantPrice?.amount
            );
      
          case "filter_low":
            return products.sort((a, b) => 
              b?.priceRangeV2?.minVariantPrice?.amount - a?.priceRangeV2?.minVariantPrice?.amount
            );
      
          default:
            return products.sort((a, b) => {
              const aIsFeatured = a.tags.includes("filter_bestseller");
              const bIsFeatured = b.tags.includes("filter_bestseller");
              
              // Featured products come first
              if (aIsFeatured && !bIsFeatured) return -1;
              if (!aIsFeatured && bIsFeatured) return 1;
              
              return 0; // Maintain original order if equal
            });
        }
      };

      const formattedDescription = collectionCdescription?.length > 0 ? collectionCdescription
            ?.split(/\n\s*\n/) // split by double newlines (paragraphs)
            ?.map(paragraph => `<p>${paragraph.trim()}</p>`)
            ?.join('') : "";
      
    return (
        <React.Fragment>
			<div className='w-full'>
                {isCleanerCoasts ? (
					<>
						{width <= 640 ? (
							<img className="w-full object-cover" src={`${mobileBannerCleaner}`} alt={'Terms and Condtions'} loading='lazy' />
						) : (
							<img className='w-full' src={`${bannerCleaner}`} alt={'Terms and Condtions'} loading='lazy' />
						)}
						<div className='text-center pt-6 text-md md:text-lg w-full '>
							<div className='text-center pl-5 pr-5'>
                                <p>Our Cleaner Coasts Collection is back - just in time for Earth Day 🌎 💙</p>
								<p>
                                    Introducing our 10 for 10 giveback: Enjoy an <span className='font-medium'>extra</span> 10% off the Cleaner Coasts 2025 Collection<br />with code <b>MAKEWAVES</b>,
                                    and we’ll donate 10% of net profits to <a className='font-semibold underline underline-offset-4' href="https://projectcurma.org/" target='_blank'>Project CURMA</a>,<br />supporting the conservation of endangered sea turtles in La Union, Philippines. 🐢
								</p>
								<p>
                                    Together, we can make waves for a cleaner, brighter tomorrow. 🌊
								</p>
								<LinkButton 
									className={'justify-self-center inline-block'}
									label={`View terms & conditions here.`}
									ariaLabel='View Cleaner Coast Terms and Condtions'
									to='/earth-day-terms-conditions'
									underline
								/>
							</div>
                    	</div>
					</>
				) : banner ? (
                    <img className='w-full' src={banner} alt={`collection-banner`} />
                ) :(
					<div className='text-center pt-11'>
                        <h2 className='m-0'>{title}</h2>
                    </div>
				)}
            </div>

            <div className="relative max-container flex flex-nowrap justify-center gap-x-8 px-4 py-6">
                <FilterList 
                    className={`${openFilterList ? 'block' : 'hidden'} fixed xl:relative top-0 left-0 w-full min-w-60 max-w-[328px] md:max-w-fit bg-white z-[60] xl:z-20 shadow-right xl:shadow-none text-sm`}
                    getFilters={handleFilters}
                    onClose={() => setOpenFilterList(false)}
                />

                <section className="flex-1">
                    <div className="flex flex-1 items-center justify-between lg:justify-end px-0 md:px-4">
                        <button
                            className="btn-outline !py-1 flex xl:hidden flex-nowrap items-center justify-between gap-x-3"
                            onClick={() => setOpenFilterList(!openFilterList)}
                            aria-label="Open Filters"
                        >
                            <div className="relative">
                            <Faders size={20} weight="light" />
                            {filterCount >= 1 && (
                                <div
                                className={`absolute size-2 bg-red-600 bottom-0 right-0 rounded-full mb-1.5`}
                                />
                            )}
                            </div>
                            <div>
                            <span>Filters</span>
                            {filterCount > 0 && (
                                <span className="ml-1">{`(${filterCount})`}</span>
                            )}
                            </div>
                        </button>

                        <div className='flex md:hidden gap-x-2'>
                            <img 
                                src={Button1Slot} 
                                className={`size-8 ${mobileGridCount !== 1 && 'opacity-50'}`}
                                alt={'1-slot'}
                                onClick={() => setMobileGridCount(1)}
                            />
                            <img 
                                src={Button2Slot} 
                                className={`size-8 ${mobileGridCount !== 2 && 'opacity-50'}`}
                                alt={'2-slot'}
                                onClick={() => setMobileGridCount(2)}
                            />
                        </div>
                    </div>

                    <div className={`${isLoading ? 'block' : 'hidden'} text-center text-md my-20`}>
                        <div className="loader mx-auto"></div>
                        <div className="pt-2 pl-2">Loading...</div>
                    </div>

                    <div className={`${isLoading ? 'hidden' : 'grid'} ${mobileGridCount === 1 ? 'grid-cols-1' : 'grid-cols-2'} md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-3 lg:gap-5 py-8 justify-items-center`}>
                        {
                            width && paginatedProducts && paginatedProducts.length > 0 ? (
                                paginatedProducts.map((product) => {
                                    if (product?.title && !product.title.includes("FREE")) {
                                        return (
                                            <div className={`col-span-1 ${mobileGridCount === 1 ? 'mx-auto' : ''}`} key={`col-${product?.id}`}>
                                                <CollectionProductCard
                                                    data={product}
                                                    cardStyles={'w-full h-full'}
                                                    width={
                                                        (mobileGridCount === 1 && width >= 425) ? '360' :
                                                        (mobileGridCount === 1 && width >= 375) ? '340' :  
                                                        (mobileGridCount === 1 && width >= 350) ? '262' :
                                                        (width >= 1024 && width < 1280) ? '320' :
                                                        (mobileGridCount === 1 || width >= 900) ? '262' :
                                                        (width >= 640) ? '240' :
                                                        (width <= 325) ? '140' :
                                                        (width <= 380) ? '160' :
                                                        (width <= 420) ? '180' : 
                                                        (width <= 768) ? '194' : 
                                                        '262'
                                                    }
                                                    height={
                                                        (mobileGridCount === 1 && width >= 425) ? '480' :
                                                        (mobileGridCount === 1 && width >= 375) ? '440' :
                                                        (mobileGridCount === 1 && width >= 350) ? '389' :
                                                        (width >= 1024 && width < 1280) ? '480' :
                                                        (mobileGridCount === 1 || width >= 900) ? '389' :
                                                        (width >= 640) ? '380' : 
                                                        (width <= 325) ? '240' :
                                                        (width <= 380) ? '240' :
                                                        (width <= 420) ? '260' : 
                                                        (width <= 768) ? '280' :  
                                                        '389'
                                                    }
                                                />
                                            </div>
                                        );
                                    }
                                })
                            ) : (
                                <div className="col-span-1 text-center">
                                    <p>No products available</p>
                                </div>
                            )
                        }
                    </div>

                    {
                        paginatedProducts && paginatedProducts.length > 0 ? (
                            <div className="flex justify-center mt-4">
                                <button
                                    disabled={currentPage <= 1}
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    className="px-4 py-2 border border-gray-300 bg-gray-100 hover:bg-gray-200"
                                    aria-label='Previous'
                                >
                                    Previous
                                </button>
                                <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
                                <button
                                    disabled={currentPage >= totalPages}
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    className="px-4 py-2 border border-gray-300 bg-gray-100 hover:bg-gray-200"
                                    aria-label='Next'
                                >
                                    Next
                                </button>
                            </div>
                        ) : <></>
                    }

                </section>
                <div
                    className={`${
                    width <= 1280 && openFilterList ? "block" : "hidden"
                    } fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-40`}
                    onClick={() => setOpenFilterList(false)}
                />

                <QuickBuyModal 
                    isOpen={openQuickBuyModal}
                    onClose={() => {
                    setQuickBuyData(null)
                    setOpenQuickBuyModal(false)
                    setAddToBagClicked(null)
                    setIsAddToCart(false)
                    }}
                    data={product}
                    isAddToCart={isAddToCart}
                />
            </div>
        </React.Fragment>
    );
}

export default CollectionsPage;